import React from "react";
import { styled, Switch } from "@mui/material";

export const GreenRedSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: "#00C853", // Green knob
      "& + .MuiSwitch-track": {
        backgroundColor: "#00C853", // Green track
      },
    },
    "&:not(.Mui-checked)": {
      color: "#FF0000", // bright red knob
      "& + .MuiSwitch-track": {
        backgroundColor: "#FF0000", // bright red track
      },
    },
  },
}));
